import React, { useEffect, useState } from 'react';
import { customerProfile } from '../../redux/customerSearchSlice';
import { useAppSelector } from '../../redux/hooks';
export const Rewardscontent = () => {
    const [pointsExpiry,setPointsExpiry]  = useState(0);
    const customerProfileData = useAppSelector(customerProfile);
    
    useEffect(() => {
        if (customerProfileData.firstName != null) {
          
          const customerPointsExpire = customerProfileData.pointToExpire;
          setPointsExpiry(customerPointsExpire);
        }
      }, [customerProfileData]);
    return (
        <div className= "grid place-items-center">
            <p className="mx-8 text-center mt-5 font-normal font-roboto">Expiring this month: &nbsp;  
                {pointsExpiry} Points
            </p>
            
            
        </div>

        
    )
}
